import ExcelJS from 'exceljs';

export function exportExcel(x='', data ){
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(x);
    const header = Object.keys(data[0])
    worksheet.addRow(header);
    data.forEach(d => {
        const row = [];
        header.forEach(h => {
            row.push(d[h]);
        });
        worksheet.addRow(row);
    });

    workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('hidden', '');
        a.setAttribute('href', url);
        a.setAttribute('download', `${x}.xlsx`);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    });
}